export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/QA-95b384b439669dae45b83d11a6a9beff.png";